import { c as _c } from "react/compiler-runtime";
import { useMedia } from 'react-use';
import { MOBILE_BREAKPOINT } from './constants';
interface IsMobileReturnType {
  isMobile: boolean;
}
export function useIsMobile() {
  const $ = _c(2);
  const isMobile = useMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
  let t0;
  if ($[0] !== isMobile) {
    t0 = {
      isMobile
    };
    $[0] = isMobile;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}